import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Loader2, Save, FileText, Clock } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../services/api';
import RichTextEditor from '../ui/RichTextEditor';

const TermsOfServiceTab = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [updatedAt, setUpdatedAt] = useState('');

  useEffect(() => {
    api.get('/system-settings/terms').then(r => {
      setContent(r.data.content || '');
      setUpdatedAt(r.data.updated_at || '');
    }).catch(() => toast.error('Failed to load Terms of Service')).finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    if (!content.trim()) { toast.error('Content cannot be empty'); return; }
    setSaving(true);
    try {
      const r = await api.put('/system-settings/terms', { content });
      setUpdatedAt(r.data.updated_at || '');
      toast.success('Terms of Service saved');
    } catch { toast.error('Failed to save'); }
    setSaving(false);
  };

  if (loading) return (
    <div className="flex items-center justify-center py-16">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
    </div>
  );

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="flex flex-row items-start justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5" /> Terms of Service
            </CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              This document is shown to users on the sign-up page and before payment. Supports rich text formatting.
            </p>
            {updatedAt && (
              <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                <Clock className="w-3 h-3" />
                Last saved: {new Date(updatedAt).toLocaleString()}
              </p>
            )}
          </div>
          <Button onClick={handleSave} disabled={saving} className="bg-primary hover:bg-primary/90 text-white shrink-0">
            {saving ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Saving...</> : <><Save className="w-4 h-4 mr-2" />Save</>}
          </Button>
        </CardHeader>
        <CardContent>
          <RichTextEditor
            value={content}
            onChange={setContent}
            minHeight="500px"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default TermsOfServiceTab;
